import React from "react";
import InfoItemInline from "./InfoItemInline";

interface Props<T> {
  title: string;
  value: T | undefined;
  formatValue?: (value: T) => string;
  isEmpty?: (value: T | undefined) => boolean;
  valueBold?: boolean;
  emptyValueText?: string;
  emptyValueBold?: boolean;
}

const CheckValueInfoItem = <T,>({
  title,
  value,
  formatValue,
  isEmpty,
  valueBold = true,
  emptyValueText = "-",
  emptyValueBold = false,
}: Props<T>) => {
  // helpers
  const getValue = () => {
    if (!isEmptyValue()) {
      if (formatValue) {
        return formatValue(value!);
      }

      return String(value);
    }

    return emptyValueText;
  };

  const hasBoldValue = () => {
    if (!isEmptyValue()) {
      return valueBold;
    } else {
      return emptyValueBold;
    }
  };

  const isEmptyValue = () => { 
    if (isEmpty) {
      return isEmpty(value);
    } else if (value) {
      return false;
    }

    return true;
  }

  // render
  return (
    <InfoItemInline
      title={title}
      value={getValue()}
      valueBold={hasBoldValue()}
    />
  );
};

export default CheckValueInfoItem;
